import compact from 'lodash.compact';
import queryString from 'query-string';
import { ID, LABEL } from '../../../../constants/shared/TrcConstants';

const {
    READING_RECORD: READING_RECORD_ID,
    COMPREHENSION: COMPREHENSION_ID,
    LANGUAGE_WRITING_GRAMMAR_SPELLING: LANGUAGE_WRITING_GRAMMAR_SPELLING_ID,
} = ID;
const { READING_RECORD, COMPREHENSION, LANGUAGE_WRITING_GRAMMAR_SPELLING } = LABEL;

const getTrcNavTabs = (search, withOptional) =>
    compact([
        {
            id: READING_RECORD_ID,
            title: READING_RECORD,
            liTagClassName: 'paragraph-button',
            path: {
                search: queryString.stringify({
                    ...search,
                    tab: READING_RECORD_ID,
                }),
            },
        },
        {
            id: COMPREHENSION_ID,
            title: COMPREHENSION,
            liTagClassName: 'comprehension-button',
            path: {
                search: queryString.stringify({
                    ...search,
                    tab: COMPREHENSION_ID,
                }),
            },
        },
        withOptional && {
            id: LANGUAGE_WRITING_GRAMMAR_SPELLING_ID,
            title: LANGUAGE_WRITING_GRAMMAR_SPELLING,
            path: {
                search: queryString.stringify({
                    ...search,
                    tab: LANGUAGE_WRITING_GRAMMAR_SPELLING_ID,
                }),
            },
        },
    ]);

export default getTrcNavTabs;
